import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "Saleem Yousuf",
        title: "Volunteer",
        biography: "Saleem Yousuf is a dedicated volunteer committed to supporting community initiatives and events at the Islamic Center. His contributions help ensure smooth operations and a welcoming environment for all attendees.",
        contacts: {
            experience: "5 years",
            phone: "000-000-0000",
            email: "saleem.yousuf@example.com",
            website: "www.saleemyousuf.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Community Event Assistance",
            "Team Collaboration",
            "Visitor Support",
            "Logistics Coordination",
            "Hospitality Services"
        ],
        specialties: [
            { id: 1, title: "Community Service", progress: 90 },
            { id: 2, title: "Team Support", progress: 85 },
            { id: 3, title: "Event Coordination", progress: 80 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Zakir Khan",
        title: "Volunteer",
        biography: "Zakir Khan is an enthusiastic volunteer who plays an active role in organizing and supporting various community activities at the Islamic Center. His dedication helps foster unity and a sense of belonging among members.",
        contacts: {
            experience: "4 years",
            phone: "000-000-0000",
            email: "zakir.khan@example.com",
            website: "www.zakirkhan.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Community Outreach",
            "Event Assistance",
            "Team Collaboration",
            "Setup & Logistics",
            "Guest Support"
        ],
        specialties: [
            { id: 1, title: "Event Support", progress: 88 },
            { id: 2, title: "Community Engagement", progress: 85 },
            { id: 3, title: "Hospitality", progress: 82 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Shumaila Mushtaq",
        title: "Volunteer",
        biography: "Shumaila Mushtaq is a committed volunteer who actively participates in organizing Islamic programs and community welfare events. She is known for her dedication, warmth, and ability to make every member feel welcomed and valued.",
        contacts: {
            experience: "3 years",
            phone: "000-000-0000",
            email: "shumaila.mushtaq@example.com",
            website: "www.shumailamushtaq.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Event Coordination",
            "Hospitality Management",
            "Community Outreach",
            "Volunteer Training",
            "Program Assistance"
        ],
        specialties: [
            { id: 1, title: "Event Management", progress: 87 },
            { id: 2, title: "Community Service", progress: 85 },
            { id: 3, title: "Team Collaboration", progress: 83 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Shahnaz Sohail",
        title: "Volunteer",
        biography: "Shahnaz Sohail is a passionate volunteer dedicated to supporting community programs, assisting with event management, and promoting Islamic values. Her kindness and organizational skills make her a valued member of the team.",
        contacts: {
            experience: "4 years",
            phone: "000-000-0000",
            email: "shahnaz.sohail@example.com",
            website: "www.shahnazsohail.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Community Program Assistance",
            "Event Coordination",
            "Volunteer Support",
            "Fundraising Activities",
            "Outreach Initiatives"
        ],
        specialties: [
            { id: 1, title: "Community Engagement", progress: 88 },
            { id: 2, title: "Event Organization", progress: 85 },
            { id: 3, title: "Teamwork", progress: 84 }
        ]
    }

];

export default team;